<!-- BudoNoticeBar -->

<template>
  <div>
    <!-- BudoNoticeBar 用 Dialog 展示 -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getSysConfigValue } from "@/api/sys-api";

export default {
  props: ['confKey'],

  mounted() {
    getSysConfigValue(this.confKey).then(res => {
      if (!res.data || 'none' == res.data) {
        return
      }

      Dialog.alert({ message: res.data, theme: 'round-button', confirmButtonColor: '#018dff' })
    })
  }
}
</script>